import config from '../../config';
import React from 'react';
import { default as withRouter } from "../../components/WithRouter/withRouter";

import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import { Icon } from 'leaflet';

import { getMarkers, getRegions, loadRegionsGeoJSONs } from '../../utils';

import styles from './ReciprocityMap.module.css';

class ReciprocityMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      position: [49, -122],
      zoom: 7,
      scrollWheelZoom: true,

      regions: [],
      markers: [],
    };
  }

  componentDidMount() {
    this.fetch();
  }

  fetch = async () => {
    this.setState({ loading: true });
    await Promise.all([
      this.getRegions(),
      this.getMarkers()
    ]);
    this.setState({ loading: false });
  }

  getRegions = async () => {
    try {
      const result = await getRegions();
      let regions = result.regions;

      await loadRegionsGeoJSONs(regions, (region, feature) => {
        if (!feature.properties) feature.properties = {};
        feature.properties.reciprocityName = `Reciprocity ${region.name}`;
      });

      this.setState({ regions: regions });
    } catch (error) {
      this.setState({ regions: [] });
    }
  }

  getMarkers = async () => {
    try {
      const result = await getMarkers();
      let markers = result.markers;

      const markersByAddress = new Map();

      markers.forEach(marker => {
        const address = marker.address;
        marker.preLaunch = false;
        const createdAt = new Date(marker.createdAt).toISOString();
        if (createdAt < '2023-06-01') {
          marker.preLaunch = true;
        }
        if (markersByAddress.has(address)) {
          if ('pledgeOnly' in marker || marker.preLaunch) {
            return;
          }
          delete markersByAddress.get(address).pledgeOnly;
          markersByAddress.get(address).years += marker.years || 0;
        } else {
          markersByAddress.set(address, { ...marker });
        }
      });
      const consolidatedMarkers = Array.from(markersByAddress.values());
      consolidatedMarkers.forEach(marker => {
        let url = `${config.assets_base_url}/pin-1-2-years.png`;
        if (marker?.pledgeOnly || marker.preLaunch) {
          url = `${config.assets_base_url}/pin-pledge.png`;
        } else if (marker.type === 'business') {
          marker.description = marker.businessName || 'Business';
          url = `${config.assets_base_url}/pin-business.png`;
        } else if (marker.type === 'renter' || marker.description === 'Renting') {
          marker.description = 'Renting';
          url = `${config.assets_base_url}/pin-renter.png`;
        } else if (marker.years > 10) {
          marker.description = `${marker.years} year property`;
          url = `${config.assets_base_url}/pin-10-years.png`;
        } else if (marker.years > 2) {
          marker.description = `${marker.years} year property`;
          url = `${config.assets_base_url}/pin-3-10-years.png`;
        }

        marker.icon = new Icon({
          iconUrl: url,
          iconRetinaUrl: url,
          iconSize: [31, 43],
          iconAnchor: [16, 37],
          popupAnchor: [0, -31]
        });
      });
      this.setState({ markers: consolidatedMarkers });
    } catch (error) {
      this.setState({ markers: [] });
    }
  }

  onEachFeature = (feature, layer) => {
    layer.bindPopup(`<h6>${feature.properties.reciprocityName}</h6>`, { maxWidth: 500 });
    layer.on('mouseover', e => { layer.setStyle({ fillOpacity: 0.5 }) });
    layer.on('mouseout', e => { layer.setStyle({ fillOpacity: 0.3 }) });
  }

  render() {
    return (
      <div className={styles.flexer}>
        <MapContainer 
          className={styles.mapContainer} 
          center={this.state.position} 
          zoom={this.state.zoom} 
          scrollWheelZoom={this.state.scrollWheelZoom} 
          maxZoom={14}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          />
          {
            this.state.markers.map((marker, index) => {
              if (marker.lat && marker.lng) {
                return <Marker key={index} position={[marker.lat, marker.lng]} icon={marker.icon}>
                  <Popup className={styles.markerPopup} maxWidth={500}>
                    <h3>{marker.description}</h3>
                  </Popup>
                </Marker>
              } else {
                return false;
              }
            })
          }
          {
            this.state.regions.map((region, index) => {
              return <GeoJSON key={index} data={region.json} coordsToLatLng={region.converter}
                onEachFeature={this.onEachFeature}
                style={{ color: region.color, fillOpacity: 0.3 }}
              />
            })
          }
        </MapContainer>
      </div>
    )
  }
}
export default withRouter(ReciprocityMap)
